import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "./components/Layout";
import { AuthProvider } from "./lib/AuthContext";

import Home from "./pages/Home";
import Announcements from "./pages/Announcements";
import AnnouncementDetail from "./pages/AnnouncementDetail";
import Competitions from "./pages/Competitions";
import Schedule from "./pages/Schedule";
import Referees from "./pages/Referees";
import Documents from "./pages/Documents";
import Structure from "./pages/Structure";
import Projects from "./pages/Projects";
import Contact from "./pages/Contact";
import InfoPage from "./pages/InfoPage";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const PublicLayout = ({ children }) => <Layout>{children}</Layout>;

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminDashboard />} />

              <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
              <Route path="/uradne-spravy" element={<PublicLayout><Announcements /></PublicLayout>} />
              <Route path="/uradne-spravy/:id" element={<PublicLayout><AnnouncementDetail /></PublicLayout>} />
              <Route path="/sutaze" element={<PublicLayout><Competitions /></PublicLayout>} />
              <Route path="/rozpis" element={<PublicLayout><Schedule /></PublicLayout>} />
              <Route path="/rozhodcovia" element={<PublicLayout><Referees /></PublicLayout>} />
              <Route path="/delegati" element={<PublicLayout><Referees /></PublicLayout>} />
              <Route path="/dokumenty" element={<PublicLayout><Documents /></PublicLayout>} />
              <Route path="/struktura" element={<PublicLayout><Structure /></PublicLayout>} />
              <Route path="/projekty" element={<PublicLayout><Projects /></PublicLayout>} />
              <Route path="/kontakt" element={<PublicLayout><Contact /></PublicLayout>} />
              <Route path="/info/:slug" element={<PublicLayout><InfoPage /></PublicLayout>} />
              <Route path="*" element={<PublicLayout><NotFound /></PublicLayout>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </HelmetProvider>
    </div>
  );
}

function NotFound() {
  return (
    <div className="container-page py-24 text-center">
      <div className="overline mb-2">404</div>
      <h1 className="text-3xl font-bold text-secondary mb-2">Stránka nebola nájdená</h1>
      <p className="text-textmuted">Skúste sa vrátiť na <a href="/">úvodnú stránku</a>.</p>
    </div>
  );
}

export default App;
